module.exports = __webpack_public_path__ + "img/marker_agricultural.2e6665ac.svg";